export function isMld(): boolean {
  // MLD installs the transport before the portal renders, in both Qt WebEngine and WebView2.
  const qtWindow = window as Window & {
    qt?: { webChannelTransport?: unknown };
  };
  return !!qtWindow.qt?.webChannelTransport;
}
